import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { HttpError } from '../models/errors/HttpError';
import { IBaseResponse, BaseResponse } from '../models/comm-http/responses/BaseResponse';
import { Response, Http, Headers } from '@angular/http';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { map, catchError, timeout } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { KeyValuePair } from '../models/KeyValuePair';
import { ssApiResponse } from '../models/ss-api/responses/ss-api.response';

@Injectable()
export class CommHttpService {


    // busy
    public IsBusy: boolean = false;

    // events
    public onIsBusyChanged = new Subject<boolean>();
    public onResponse = new Subject<ssApiResponse>();
    public onUnauthorized = new Subject<boolean>();

    // router public because it is used in other classes
    constructor(private httpMain: Http) {
    }

    protected SetBusy(): void {
        this.IsBusy = true;
        this.onIsBusyChanged.next(true);
    }

    protected UnsetBusy(): void {
        this.IsBusy = false;
        this.onIsBusyChanged.next(false);
    }

    private StatusCodeToFriendlyMessage(code: number, defaultValue: string = ''): string {

        switch (code) {

            case 401:
                return 'Wrong username or password!'

            default:
                return defaultValue;
        }

    }

    private ErrorToFriendlyMessage(response: Response): string {

        // check first error in header
        let headerKeys = response.headers.keys();
        // console.log(headerKeys);

        // headers?
        if (!headerKeys) {
            // return from status
            return this.StatusCodeToFriendlyMessage(response.status, response.statusText);
        }

        // check from headers
        if (headerKeys.some(x => x === 'autherrorcode')) {
            let code = response.headers.get('autherrorcode')

            switch (code) {

                case '0':
                    return response.headers.get('autherror');

                case '1':
                    return 'Wrong Username or Password';

                default:
                    // return from status
                    return this.StatusCodeToFriendlyMessage(response.status, response.statusText);
            }

        }

    }


    private HandleError(error: Response): Observable<any> {

        // console.log("Error handling");
        // console.log(error);

        // let errorResponse: any;

        // if (error.status === 0)
        //     errorResponse = new HttpNoConnectionError(error);

        if (error.status === 401)
            // errorResponse = new HttpUnauthorized(error);
            // this.gs.Logout();
            this.onUnauthorized.next(true);

        // else if (error.status === 403)
        //     errorResponse = new HttpForbidden(error);

        // else if (error.status === 404)
        //    errorResponse = new HttpNotFoundError(error);

        //  else if (error.status === 400)
        //     errorResponse = new BadRequest(error.json());

        //  else
        let errorResponse = new HttpError(error);
        errorResponse.FriendlyTitle = 'Error';

        if (error.status == 0) {
            errorResponse.FriendlyTitle = 'Connection Error'
            errorResponse.FriendlyMessage = 'Unable to connect to server.';
        } else {
            errorResponse.FriendlyMessage = error.statusText;
        }


        return throwError(error);
        // return Observable.throw(errorResponse);

    }

    private ConvertToBaseResponse<T>(data: Response): IBaseResponse<T> {
        let value = data.json() as IBaseResponse<T>;
        value.HttpResponse = data;
        return value;
    };

    protected Post<T>(url: string, data: any, headers: Headers = null, withCredentials: boolean = true, timeoutOverride: number = 120000): Observable<IBaseResponse<T>> {

        let reqHeaders: Headers = headers ? headers : new Headers();

        return this.httpMain.post(url, data, { headers: reqHeaders, withCredentials: withCredentials }).pipe(
            timeout(timeoutOverride),
            map(response => this.ConvertToBaseResponse<T>(response)),
            catchError(
            (error) => {

                // if ((error as Response).status == 401)
                //   this.onAuthError.next(error.statusText);

                return this.HandleError(error);
            })
        )
    }

    protected PostRaw(url: string, data: any, headers: Headers = null, withCredentials: boolean = true): Observable<any> {

        let reqHeaders: Headers = headers ? headers : new Headers();

        return this.httpMain.post(url, data, { headers: reqHeaders, withCredentials: withCredentials }).pipe(
            timeout(120000),
            catchError(
                (error) => {

                    // if ((error as Response).status == 401)
                    //   this.onAuthError.next(error.statusText);

                    return this.HandleError(error);
            })
        )
    }


    protected Patch<T>(url: string, data: any, headers: Headers = null): Observable<IBaseResponse<T>> {

        let reqHeaders: Headers = headers ? headers : new Headers();

        return this.httpMain.patch(url, data, { headers: reqHeaders, withCredentials: true }).pipe(
            timeout(120000),
            map(response => this.ConvertToBaseResponse<T>(response)),
            catchError(
            (error) => {

                // if ((error as Response).status == 401)
                //   this.onAuthError.next(error.statusText);

                return this.HandleError(error);
            })

        )
    }


    protected Delete<T>(url: string, headers: Headers = null): Observable<IBaseResponse<T>> {

        let reqHeaders: Headers = headers ? headers : new Headers();
        let qData = '';


        return this.httpMain.delete(url, { headers: reqHeaders, withCredentials: true }).pipe(
            timeout(120000),
            map(
                (response: Response) => {
                    let value = response.json() as IBaseResponse<T>;
                    value.HttpResponse = response;
                    return value;
                }),
            catchError(
            (error) => {

                // if ((error as Response).status == 401)
                //    this.onAuthError.next(error.statusText);

                return this.HandleError(error);
            })
        )
    }


    protected GetCore<T>(converter: any, url: string, queryData: KeyValuePair<string, string>[] = null, headers: Headers = null): Observable<IBaseResponse<T>> {

        let reqHeaders: Headers = headers ? headers : new Headers();
        let qData = '';

        if (queryData != null) {
            qData = '?';
            for (let item of queryData) {
                qData += item.Key + '=' + item.Value;
            }
        }

        return this.httpMain.get(url, { headers: reqHeaders, withCredentials: true }).pipe(
            timeout(120000),
            map(
                (response: Response) => {

                    return converter(response);

                }),
            catchError(
            (error) => {

                // if ((error as Response).status == 401)
                //  this.onAuthError.next(error.statusText);

                return this.HandleError(error);
            })
        )

    }

    protected Get<T>(url: string, queryData: KeyValuePair<string, string>[] = null, headers: Headers = null): Observable<IBaseResponse<T>> {

        // only properties

        let converter =
            function (response: Response) {
                // console.log("get simple");
                // console.log(response);

                let value = response.json() as IBaseResponse<T>;
                value.HttpResponse = response;
                return value;
            }

        return this.GetCore<T>(converter, url, queryData, headers);
    }

    private getTokenHeader(): Headers {

        let token = localStorage.getItem('crm_token');
        let headers = new Headers();

        if (token != undefined) {
            headers.set('Authorization', 'Bearer ' + token);
        }

        return headers;
    }

    private FullURL(baseUrl: string, url: string): string {
        return baseUrl + url;
    }

    protected prepGet<T>(referalMethod: string, baseUrl: string, url: string, data: string = ''): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(baseUrl, url) + data;
        let headers = this.getTokenHeader();

        // request
        return this.Get<T>(url, null, headers).pipe(
            map(response => {
                this.UnsetBusy();

                let apiResponse = new ssApiResponse(url, referalMethod, response);
                this.onResponse.next(apiResponse);
                return response;
            }),
            catchError((error: HttpError) => {
                this.UnsetBusy();
                return throwError(error);
                // return Observable.throw(error);
            })
        )

    }

    protected prepGetWithBody<T>(referalMethod: string, request: any, baseUrl: string, url: string): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(baseUrl, url);
        let headers = this.getTokenHeader();

        // request
        return this.Get<T>(url, request, headers).pipe(
            map(response => {
                this.UnsetBusy();

                let apiResponse = new ssApiResponse(url, referalMethod, response);
                this.onResponse.next(apiResponse);
                return response;

            }),
            catchError((error: HttpError) => {
                this.UnsetBusy();
                return throwError(error);
                // return Observable.throw(error);
            })
        )

    }

    protected prepPOST<T>(referalMethod: string, request: any,   baseUrl: string, url: string, timeoutOverride: number = 120000): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(baseUrl, url);
        let headers = this.getTokenHeader();

        // request
        return this.Post<T>(url, request, headers, true, timeoutOverride).pipe(
            map(response => {
                this.UnsetBusy();

                let apiResponse = new ssApiResponse(url, referalMethod, response);
                this.onResponse.next(apiResponse);
                return response;

            }),
            catchError((error: HttpError) => {
                this.UnsetBusy();
                return throwError(error);
                // return Observable.throw(error);
            })
        )

    }


    protected prepPATCH<T>(referalMethod: string, request: any, baseUrl: string, url: string): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(baseUrl, url);
        let headers = this.getTokenHeader();

        // request
        return this.Patch<T>(url, request, headers).pipe(
            map(response => {
                this.UnsetBusy();

                let apiResponse = new ssApiResponse(url, referalMethod, response);
                this.onResponse.next(apiResponse);
                return response;

            }),
            catchError((error: HttpError) => {
                this.UnsetBusy();
                return throwError(error);
                // return Observable.throw(error);
            })
        )

    }

    protected prepDelete<T>(referalMethod: string, baseUrl: string, url: string, data: string = ''): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(baseUrl, url) + data;
        let headers = this.getTokenHeader();

        // request
        return this.Delete<T>(url, headers).pipe(
            map(response => {
                this.UnsetBusy();

                let apiResponse = new ssApiResponse(url, referalMethod, response);
                this.onResponse.next(apiResponse);
                return response;

            }),
            catchError((error: HttpError) => {
                this.UnsetBusy();
                return throwError(error);
                // return Observable.throw(error);
            })
        )

    }


}
